import { render } from "./DigestCircle.vue?vue&type=template&id=3ae97161&scoped=true&ts=true"
import script from "./DigestCircle.vue?vue&type=script&lang=ts"
export * from "./DigestCircle.vue?vue&type=script&lang=ts"

import "./DigestCircle.vue?vue&type=style&index=0&id=3ae97161&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae97161"]])

export default __exports__